<ds-modal
  #previewFileModal
  [ds-modal-trigger-for]="previewFileModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '770px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header>{{ 'backoffice.previewFileModal.title' | translate: { fileName: file().filename } }}</ds-box-header>

  <ds-box-content class="content">
    <pre class="size">{{ JSON.stringify(JSON.parse(file().fileContent), null, 2) }}</pre>
  </ds-box-content>

  <ds-box-footer>
    <button id="btn-close-modal" ds-button #dsModalDismissElement>
      {{ 'common.buttons.close' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
